import React from "react";
import { useParams } from "react-router-dom";

const VIDEO_MAP = {
  led500w: "/videos/LED_dimmer_500W.mp4",
  // ...추가
};

export default function VideoPlayer() {
  const { videoId } = useParams();
  const src = VIDEO_MAP[videoId];
  if (!src) return null;

  // 바디, html 스타일을 직접 바꿔서 "진짜" 전체화면 느낌
  React.useEffect(() => {
    const prevBg = document.body.style.background;
    document.body.style.background = "#000";
    document.body.style.margin = "0";
    return () => {
      document.body.style.background = prevBg;
      document.body.style.margin = "";
    };
  }, []);

  return (
    <video
      src={src}
      controls
      autoPlay
      playsInline
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100vw",
        height: "100vh",
        background: "#222",
        objectFit: "contain",
        border: "none",
        zIndex: 9999,
      }}
    />
  );
}
